
import { cn } from "@/lib/utils";

const customizations = [
  {
    title: "Custom Material Selection",
    description: "Choose from a wide range of specialized materials including high-grade stainless steel, advanced ceramic, and engineered polymers. We tailor the material composition to withstand specific environmental challenges such as extreme temperatures, corrosive chemicals, or high moisture levels.",
    image: "/images/custom_materials.png"
  },
  {
    title: "Special Coatings & Treatments",
    description: "Enhance your bearing's performance and lifespan with our specialized surface coatings. Options include anti-corrosion plasma treatments, low-friction PTFE coatings, and localized hardening. These treatments are essential for operations in highly abrasive or heavy-load conditions.",
    image: "/images/special_coatings.png"
  },
  {
    title: "Custom Dimensions & Tolerances",
    description: "We provide tailor-made bearings engineered with precise dimensions and ultra-fine tolerances to meet your unique application requirements. Whether you need a non-standard bore size, specialized outer geometry, or specific radial clearance, our engineering team will deliver a perfect fit.",
    image: "/images/custom_dimensions.png"
  }
];

export function CustomizationSection() {
  return (
    <section id="customization" className="py-16 md:py-24 bg-gradient-to-b from-background to-muted/30">
      <div className="container">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Customization Options</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We offer extensive customization to meet your precise requirements
          </p>
        </div>

        <div className="space-y-12 md:space-y-16">
          {customizations.map((item, index) => (
            <div
              key={index}
              className={cn(
                "flex flex-col md:flex-row gap-8 items-center",
                index % 2 === 1 && "md:flex-row-reverse"
              )}
            >
              <div className="md:w-1/3">
                <div className="rounded-lg overflow-hidden border bg-background/50 shadow-sm">
                  <img
                    src={item.image}
                    alt={`${item.title} - custom bearing solutions by Avon Bearings`}
                    className="w-full h-auto object-cover aspect-video sm:aspect-square md:aspect-[4/3]"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="md:w-2/3 space-y-4">
                <h3 className="text-2xl md:text-3xl font-bold">{item.title}</h3>
                <p className="text-muted-foreground text-lg leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
